<app-strip-top-dev-environment></app-strip-top-dev-environment>
<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-platform-fab></app-platform-fab>
</ion-app>